var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ed0000;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.65,24.96h14.52c.06,0,.12,0,.18.02l1.92-1.92,2.89-2.89,1.64-1.63v-6.61l-9.21,1.5c-.05,0-.11.01-.16.01-.47,0-.88-.33-.98-.8l-1.36-6.89h-14.38c-.93,0-1.69.75-1.69,1.69v33.11c0,.93.75,1.69,1.69,1.69h24.41c.93,0,1.69-.75,1.69-1.69v-11.72l-4.46,4.46c-.21.21-.45.37-.72.47l-1.82.73-1.63.66c-.26.1-.53.15-.8.15-.45,0-.87-.13-1.24-.39-.11-.07-.21-.16-.3-.25-.24-.24-.41-.52-.52-.83h-9.64c-.56,0-1.01-.46-1-1.02,0-.55.48-.98,1.03-.98h9.84l1.2-2.98c.11-.28.27-.52.48-.73l1.17-1.17h-12.69c-.55,0-1.02-.43-1.03-.98-.01-.56.44-1.02,1-1.02ZM13.65,19.09c0-.55.45-1,1-1h14.52c.55,0,1,.45,1,1s-.45,1-1,1h-14.52c-.55,0-1-.45-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.61,10.26l-5.98.98c-.23.04-.45-.11-.49-.34l-.86-4.33,7.33,3.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.56,16.96c0,.55-.21,1.06-.6,1.44l-6.9,6.9-1.26,1.26-.51.51-4.19,4.19-.89.89c-.06.06-.12.1-.19.13h-.02s-1.81.73-1.81.73l-1.47.59-.16.06c-.07.03-.14.04-.22.04-.12,0-.24-.04-.33-.1-.03-.02-.05-.04-.08-.06-.16-.16-.21-.41-.13-.63l.4-1,.03-.07.25-.64.7-1.75c.03-.07.07-.14.13-.19l3.93-3.93.67-.67h0l3.36-3.36.51-.51,1.26-1.26,4.02-4.01c.39-.39.9-.6,1.44-.6s1.06.21,1.44.6c.39.39.6.9.6,1.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/audit-log.a712ffc3cbf8c74ac873bf69b4738e21.svg";
export { ForwardRef as ReactComponent };